<template>
    <div
        class="gc-flex"
        :class="getClasses"
    >
        <slot/>
    </div>
</template>

<script>

import { defineComponent, useAttrs, computed } from "vue"

export default defineComponent({
    name: "VFlex",
    setup() {

        const attrs = useAttrs()
        const getClasses = computed(() => {
            return Object.keys(attrs)
        })
        return {
            attrs,
            getClasses
        }
    }

})
</script>

<style lang="scss" scoped>
.gc-flex {
    flex: 1 1 auto;
    max-width: 100%;
}
</style>
